// extracted by mini-css-extract-plugin
var _1 = "UniversalCouponInput_couponInput__l1ZBx";
var _2 = "UniversalCouponInput_couponInputContainer__39ceq";
var _3 = "UniversalCouponInput_couponInputInvalid__M4bU+";
var _4 = "UniversalCouponInput_couponInputLabel__Zx3MP";
var _5 = "UniversalCouponInput_defaultInputWrapper__4qFbM";
var _6 = "UniversalCouponInput_discounAndLabel__LKwtZ";
var _7 = "UniversalCouponInput_secondaryInputWrapper__BBruQ";
var _8 = "UniversalCouponInput_successMessage__tYvt7";
export { _1 as "couponInput", _2 as "couponInputContainer", _3 as "couponInputInvalid", _4 as "couponInputLabel", _5 as "defaultInputWrapper", _6 as "discounAndLabel", _7 as "secondaryInputWrapper", _8 as "successMessage" }
